import { Injectable } from '@angular/core';
import { MatDialogConfig, MatSnackBar } from '@angular/material';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    constructor(
        private snackBar: MatSnackBar) {

    }

    getSubdominio(): string {
        let host = location.host;
        // remove o 'www' inicial
        if (host.startsWith('www.')) {
            host = host.substring(4);
        }

        let subdominio;
        if (host === environment.varejoHost) {
            subdominio = "";
        } else if (environment.local && host == 'localhost:4202') {
            subdominio = "fenacon";
        } else {
            let index = host.indexOf(".");
            subdominio = (index > 0) ? host.substring(0, index) : host;
        }

        return subdominio;
    }

    showError(message: string) {
        this.snackBar.open(message, "x", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ['error-snackbar']
        });
    }

    showSuccess(message: string) {
        this.snackBar.open(message, "x", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ['success-snackbar']
        });
    }

    configuracaoDialog(): MatDialogConfig {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;

        return dialogConfig;
    }
}
